
const m = window.require("css-mediaquery");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
